import React from 'react';
import { Dialog, DialogPanel } from '@headlessui/react';
import { faX } from '@fortawesome/pro-regular-svg-icons';

// Types
import { DrawerProps } from '../../types/display/drawer';

// Components
import { Icon } from './Icon';
import classNames from 'classnames';

export const Drawer = ({
  open,
  title,
  footer,
  setOpen,
  children,
  position = 'right',
}: DrawerProps) => (
  <Dialog open={open} onClose={() => setOpen(false)}>
    <DialogPanel as="div" className="offcanvas-backdrop">
      <div
        className={classNames('offcanvas grid w-sm', {
          'offcanvas-top': position === 'top',
          'offcanvas-bottom': position === 'bottom',
          'offcanvas-inline-end': position === 'right',
          'offcanvas-inline-start': position === 'left',
        })}
      >
        <div className="offcanvas-panel">
          <header className="repel">
            <div className="flow">
              <h3>{title}</h3>
            </div>
            <div className="cluster gap-sm">
              <button
                title="Close panel"
                onClick={() => setOpen(false)}
                className="icon-button self-start"
                aria-label="Close off canvas panel"
              >
                <Icon icon={faX} />
              </button>
            </div>
          </header>
          <article className="flow justify-items-stretch h-100%">
            <div>{children}</div>
          </article>
          {footer}
        </div>
      </div>
    </DialogPanel>
  </Dialog>
);
